import { accessibilityConstants } from './accessibility.Constants';

export function storeAccessibilityData(data) {
  return dispatch => {
    dispatch({ type: accessibilityConstants.STORE_ACCESSIBILITY_DATA, data });
  }
}